const extensionConfigurationRoutes = [
    {
        path: "/account-settings",
        name: "accountSettings",
        component: () => import("@/views/Pages/ExtensionConfiguration/AccountSettings.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account-categories",
        name: "accountCategories",
        component: () => import("@/views/Pages/ExtensionConfiguration/Categories.vue"),
        meta: {
            requiresAuth: true,
        },
    },
     {
        path: "/account-government-tlds",
        name: "accountGovernmentTlds",
        component: () => import("@/views/Pages/ExtensionConfiguration/GovernmentTlds.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account-ai-categories",
        name: "accountAiCategories",
        component: () => import("@/views/Pages/ExtensionConfiguration/AiCategories.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account-doh-blocking",
        name: "accountDohBlocking",
        component: () => import("@/views/Pages/ExtensionConfiguration/DohBlocking.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account-allow-list",
        name: "allowlist",
        component: () => import("@/views/Pages/AllowList/AllowList.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account-block-list",
        name: "blocklist",
        component: () => import("@/views/Pages/BlockList/BlockList.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account-domain-list",
        name: "domainlist",
        component: () => import("@/views/Pages/DomainList/DomainList.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account-extension-keys",
        name: "extension_keys",
        component: () => import("@/views/Pages/ExtensionConfiguration/ExtensionKeys.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account-ips",
        name: "account_ips",
        component: () => import("@/views/Pages/ExtensionConfiguration/AccountIPs.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account-domains",
        name: "account_domains",
        component: () => import("@/views/Pages/ExtensionConfiguration/AccountDomains.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account-api-keys",
        name: "account_api_keys",
        component: () => import("@/views/Pages/ExtensionConfiguration/AccountApiKeys.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/platform-guide/installation",
        name: "platform_guide_installation",
        component: () => import("@/views/Pages/ExtensionConfiguration/InstallationGuide.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/platform-guide/user-guide",
        name: "platform_guide_user_guide",
        component: () => import("@/views/Pages/ExtensionConfiguration/UserGuide.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/platform-guide/changelogs",
        name: "platform_guide_changelogs",
        component: () => import("@/views/Pages/ExtensionConfiguration/Changelogs.vue"),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/installation-guide",
        redirect: "/platform-guide/installation"
    },
]

export default extensionConfigurationRoutes